import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@fontsource/jost/300.css";
import "@fontsource/jost/400.css";
import "@fontsource/jost/500.css";
import "@fontsource/jost/600.css";
import "@fontsource/jost/700.css";
import App from "./App.tsx";
import "./index.css";

// Auto-recover from stale chunks after deploys / dev-server restarts.
// "Failed to fetch dynamically imported module" usually means the previously
// loaded chunk hash no longer exists on the server; a single reload fixes it.
if (typeof window !== "undefined") {
  const isChunkLoadError = (msg: unknown) =>
    typeof msg === "string" &&
    (msg.includes("Failed to fetch dynamically imported module") ||
      msg.includes("Importing a module script failed"));
  const reloadOnce = () => {
    const key = "__chunk_reload_at";
    const last = Number(sessionStorage.getItem(key) || 0);
    if (Date.now() - last < 10_000) return; // avoid reload loops
    sessionStorage.setItem(key, String(Date.now()));
    window.location.reload();
  };
  window.addEventListener("error", (e) => {
    if (isChunkLoadError(e.message)) reloadOnce();
  });
  window.addEventListener("unhandledrejection", (e) => {
    const msg = (e.reason && (e.reason.message || String(e.reason))) || "";
    if (isChunkLoadError(msg)) reloadOnce();
  });
}

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

